import { COLOR_UI_HIGHLIGHT, COLOR_GREEN_700 } from '@alltrails/shared/denali/tokens';
import { addLayer, removeLayer, addLayerEvent } from '../layers/layer_helpers';
import { addOrUpdateGeojsonSource } from '../sources/geojson_helpers';
import { addHoverPopupToMap } from '../event_handling/popup_helpers';
import { removeSource } from '../sources/source_helpers';

const NEW_POLYLINE_COORDINATES = [-1, 0, 1, 0];

const getNewPolylineLayerId = (id, i) => id + i;

const addPolylines = (map, id, geojson, sourceOpts = {}, opts = {}, addUnderLayerTypes = null, isMapCreatorPage) => {
  // Even though we have a default parameter value some callers may pass in null or undefined.
  opts = opts || {};

  addOrUpdateGeojsonSource(map, id, geojson, sourceOpts);
  if (map.getLayer(id)) {
    return;
  }

  const isAdmin = __AT_DATA__.store?.user?.admin;
  const isNewPolylineColor = !isAdmin;

  // when drawing a map isMapCreatorPage is undefined
  if (isMapCreatorPage !== undefined && isNewPolylineColor && !isMapCreatorPage) {
    // loop thorugh the coordinates - for each coordinate add layer with polyline
    NEW_POLYLINE_COORDINATES.forEach((coord, i) => {
      addLayer(
        map,
        {
          id: getNewPolylineLayerId(id, i),
          type: 'line',
          source: id,
          layout: {
            'line-join': 'round',
            'line-cap': 'round'
          },
          paint: {
            'line-color': opts['line-color'] ? opts['line-color'] : i === 3 ? COLOR_UI_HIGHLIGHT : COLOR_GREEN_700,
            'line-width': i === 3 ? 4 : 2,
            'line-offset': coord * 3
          }
        },
        addUnderLayerTypes,
        'osm-alltrails-lines-public'
      );
    });
  } else {
    addLayer(
      map,
      {
        id,
        type: 'line',
        source: id,
        paint: {
          'line-color': opts['line-color'] ? opts['line-color'] : ['coalesce', ['get', 'color'], 'red'],
          'line-width': opts['line-width'] || 5
        }
      },
      addUnderLayerTypes
    );
  }
  if (opts && opts.renderPopup) {
    addLayerEvent(map, id, true, 'mouseenter', () => {
      map.getCanvas().style.cursor = 'pointer';
    });
    addLayerEvent(map, id, true, 'mouseleave', () => {
      map.getCanvas().style.cursor = map.customStyle.cursor;
    });

    addHoverPopupToMap(map, id, opts.renderPopup);
  }
};

const updatePolylines = (map, id, key, primaryValue, secondaryValue) => {
  const isAdmin = __AT_DATA__.store?.user?.admin;

  if (!isAdmin) {
    NEW_POLYLINE_COORDINATES.forEach((_, i) => {
      if (!map.getLayer(getNewPolylineLayerId(id, i))) return;

      if (i === 3) {
        map.setPaintProperty(getNewPolylineLayerId(id, i), key, primaryValue);
      } else {
        map.setPaintProperty(getNewPolylineLayerId(id, i), key, secondaryValue ?? primaryValue);
      }
    });
  } else {
    if (!map.getLayer(id)) return;
    map.setPaintProperty(id, key, primaryValue);
  }
};

const removePolylines = (map, id) => {
  const isAdmin = __AT_DATA__.store?.user?.admin;

  if (!isAdmin) {
    NEW_POLYLINE_COORDINATES.forEach((_, i) => {
      removeLayer(map, getNewPolylineLayerId(id, i));
    });
  } else {
    removeLayer(map, id);
  }
  removeSource(map, id);
};

export { addPolylines, removePolylines, updatePolylines };
